/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Crm_Contact_Opted_OutInputs */

const en_error_crm_contact_opted_out = /** @type {(inputs: Error_Crm_Contact_Opted_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This person said no to Tomorrow's emails: there is no link to send them.`)
};

/**
* | output |
* | --- |
* | "This person said no to Tomorrow's emails: there is no link to send them." |
*
* @param {Error_Crm_Contact_Opted_OutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_crm_contact_opted_out = /** @type {((inputs?: Error_Crm_Contact_Opted_OutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Crm_Contact_Opted_OutInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_crm_contact_opted_out(inputs)
});